var $ = jQuery;
import { projectGrid } from '../components/projects';
import {videoHover} from "../components/video";
import {projectProximityCursor} from "../components/projects";
import { gsap } from 'gsap';

/*
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
Barba page transitions won't work on elements
injected via ajax when using the localhost:8000
proxy (e.g. the featured-project transition on
project archive).
Please use the mmmultiply.local.
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/

const pagination = {
    init(){
        const btn = document.querySelectorAll('.js-pagination-load-more');   
        const postWrapper =  document.querySelector('[data-featuredprojectscontainer] .js-projects');   
        // const postWrapperClasslist = postWrapper.querySelector('.js-projects-inner').classList;
        if (btn.length > 0) {

            var currentPage = 1;

            function loadMore(paged) {
                $.ajax({
                    type: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    dataType: 'json',
                    data: {
                      action: 'weichie_load_more',
                      paged: paged,
                    },
                    success: function (res) {

                        async function postsPrep() {
                            $('.js-project-archive .js-projects').append(res.html);
                            // pageTransitions.init(); 
                            videoHover.init();
                            projectProximityCursor.init();
                            projectGrid.init();
                        }
                        postsPrep().then(() => {	
                            // !!!!!!!!!!!!!!!!!!!!!!!!
                            // Ideally this should call animation.js -> doFadeAni()
                            // !!!!!!!!!!!!!!!!!!!!!!!!
                            let postsHidden = [];
                            var posts = document.querySelectorAll('.js-project-archive.js-fade-ani-trigger .js-fade-ani');
                            posts.forEach(function(post) {
                                if (post.style.opacity == 0) {
                                    postsHidden.push(post);
                                }
                            });

                            gsap.fromTo(postsHidden, 1.5, {
                                y: '-30',
                                opacity: 0,
                            },
                            {
                                y: 0,
                                opacity: 1,
                                ease: 'power3.out',
                                stagger: {
                                    each: 0.2,
                                    onComplete:function(){
                                        gsap.set(this.targets()[0], {'pointer-events': 'auto'});
                                    }						
                                },
                                // onComplete: () => done(),
                            })
                            ; 

                        });
                                                
                        if(paged >= res.max) {

                            gsap.to(btn[0], 0.5, {
                                opacity: 0
                            });
                            btn[0].style.pointerEvents = 'none';

                        }


                    }
                });                
            }            

            let newPage = 1;

            btn[0].addEventListener('click', function(e){                
                loadMore(newPage + 1);
                newPage++;
            });

        }
    }
}

export default pagination;